module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/features/buttons/icon-buttons/icon-buttons.component.scss
// module id = ./src/app/features/buttons/icon-buttons/icon-buttons.component.scss
// module chunks = main